import getJiaMengStoreMenu from './JiaMengStore'

export default () => {
  return getJiaMengStoreMenu()
}
